@if (group(); as g) {
	@if (label()) {
		<label
			[for]="labelForId()"
			[ngClass]="hasVisibleError() ? 'text-danger' : ''"
			>{{ label() }}</label
		>
	}
	<div
		[ngClass]="hasVisibleError() ? 'force-display-feedback is-invalid' : null"
	>
		<div
			class="d-flex align-items-start gap-2"
			id="{{ labelForId() }}"
			[formGroup]="g"
		>
			<div class="flex-grow-1">
				<ae-single-date-picker
					formControlName="from"
					[id]="labelForId() + '.from'"
				/>
			</div>
			<span class="pt-1">-</span>
			<div class="flex-grow-1">
				<ae-single-date-picker
					formControlName="to"
					[id]="labelForId() + '.to'"
				/>
			</div>
		</div>
		@if (
			g.errors?.['required'] &&
			g.controls.from.touched &&
			g.controls.from.dirty &&
			g.controls.to.touched &&
			g.controls.to.dirty
		) {
			<div class="invalid-feedback">From and To are required</div>
		}
		@if (
			g.errors?.fromRequired &&
			g.controls.from.touched &&
			g.controls.from.dirty &&
			g.controls.to.touched &&
			g.controls.to.dirty
		) {
			<div class="invalid-feedback">
				From must have a value when To has a value
			</div>
		}
		@if (
			g.errors?.toRequired &&
			g.controls.from.touched &&
			g.controls.from.dirty &&
			g.controls.to.touched &&
			g.controls.to.dirty
		) {
			<div class="invalid-feedback">
				To must have a value when From has a value
			</div>
		}
		@if (g.errors?.['invalidPeriod']) {
			<div class="invalid-feedback">From date must be before To date</div>
		}
	</div>
}
